import React from 'react';
import { Autocomplete } from '@material-ui/lab';
import { TextField, Chip, Box } from '@material-ui/core';

const TagsSelect = ({
  tags,
  value,
  onChange,
  label = "Filtrar por Tags",
  placeholder = "Selecciona tags...",
  ...props
}) => {
  return (
    <Autocomplete
      multiple
      options={tags}
      value={value}
      onChange={(event, newValue) => onChange(newValue)}
      getOptionLabel={(option) => option.name}
      disableCloseOnSelect
      noOptionsText="No hay opciones"
      loadingText="Cargando..."
      openOnFocus 
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={label}
          placeholder={placeholder}
          margin="dense"
        />
      )}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip
            key={option.id}
            label={option.name}
            size="small"
            style={{ backgroundColor: option.color, color: "white" }}
            {...getTagProps({ index })}
          />
        ))
      }
      renderOption={(option) => (
        <React.Fragment>
          <Box
            component="span"
            style={{
              width: 18,
              height: 18,
              flexShrink: 0,
              borderRadius: "3px",
              marginRight: "8px",
              backgroundColor: option.color,
            }}
          />
          {option.name}
        </React.Fragment>
      )}
      {...props}
    />
  );
};

export default TagsSelect;